import { folderInfoFrag } from '../../../../../../utils/type/folder.common-type';
import { userInfoFrag } from '../../../../../../utils/type/user.common-type';

export const getMailsFrag = `
    id
    serviceId
    folderId
    direction
    type
    info
    state
    mailYear
    mailNumber
    sender
    recipient
    userIds
    users {
        ${userInfoFrag} 
    }
    folderId
    folder {
        ${folderInfoFrag}
    }
    sendDate
    receiveDate
    deadline
    note
    parcelFileId
    relatedFileId
`;
